// document.addEventListener('DOMContentLoaded', function () {
//     const swipers = document.querySelectorAll('.swiper-container');
//     swipers.forEach(function (container) {
//         var swiper = new Swiper(container, {
//             pagination: {
//                 el: '.swiper-pagination',
//                 clickable: true,
//             },
//             loop: true,
//         });
//     });
// });

const ROOT = (((window.Shopify || {}).routes || {}).root) || '/';

// Fetch the cart JSON
async function getCart() {
    const res = await fetch(`${ROOT}cart.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js failed');
    return res.json();
}

// Current variant id from the product form
function getCurrentVariantId() {
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!input) return null;
    const id = parseInt(input.value, 10);
    return Number.isFinite(id) ? id : null;
}

// Selected tier quantity from Hulk radios (3, 6, 9, ...)
function getSelectedTierQty() {
    const radio = document.querySelector('.hulkapps-volumes input[name="card_group"]:checked');
    if (!radio) return null;
    const val = parseInt(radio.value, 10);
    return Number.isFinite(val) ? val : null;
}

// How many of this variant are in the cart
function getVariantQtyInCart(cart, variantId) {
    if (!variantId) return 0;
    return cart.items.reduce((sum, it) => sum + (it.variant_id === variantId ? it.quantity : 0), 0);
}

// --------------- Helpers ---------------

// Some UIs use Arabic-Indic digits (e.g., ٨٠٫٠٠). Convert them to 80.00 so JS can parse.
function normalizeDigits(str) {
    const map = { '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4', '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9' };
    return String(str).replace(/[٠-٩]/g, d => map[d] || d);
}

// Try to read the "price per piece" from the selected Hulk tier label.
// Returns the amount in CENTS (integer) or null if not found.
function getSelectedTierUnitPriceCents() {
    // Find which deal is selected (Hulk uses radios like value=3,6,9…)
    const radio = document.querySelector('.hulkapps-volumes input[name="card_group"]:checked');
    if (!radio) return null;

    // Find the label for that radio (contains the price text)
    const label =
        document.querySelector(`label[for="${radio.id}"]`) ||
        radio.closest('label');

    if (!label) return null;

    // Prefer the little pill that has "/PIECE" or Arabic "لكل / قطعة"
    const spans = Array.from(label.querySelectorAll('span'));
    const priceSpan = spans.find(sp => /\/\s*PIECE|\bPER\s+PIECE\b|لكل|قطعة/i.test(sp.textContent || ''));

    // Take the text, normalize Arabic digits, and keep only digits + separators
    const raw = normalizeDigits((priceSpan ? priceSpan.textContent : label.textContent) || '');
    const cleaned = raw.replace(/[^\d.,]/g, '').replace(/,/g, '.'); // "65.00" for both "65,00" and "65.00"

    // Grab the first number we see
    const match = cleaned.match(/(\d+(\.\d+)?)/);
    if (!match) return null;

    const amount = parseFloat(match[1]);
    if (!Number.isFinite(amount)) return null;

    return Math.round(amount * 100); // turn "65.00" into 6500 cents
}

// --------------- Discount checker ---------------

// Keep polling /cart.js until the discount is visible on the target variant.
// - variantId: the variant we just added (number)
// - expectedUnitCents: optional; the expected per-piece price from the tier (in cents)
// Returns the updated cart when discount is confirmed, or throws on timeout.
async function ensureDiscountApplied({ variantId, expectedUnitCents = null, timeout = 15000, interval = 250 } = {}) {
    const deadline = Date.now() + timeout;

    while (Date.now() < deadline) {
        // Pull the latest cart (Shopify returns cents everywhere)
        const cart = await getCart();

        // Find the cart line for THIS variant
        const item = cart.items.find(it => it.variant_id === variantId);

        if (item && item.quantity > 0) {
            // Facts from /cart.js:
            // - item.price is the original unit price (cents)
            // - item.total_discount is the total discount on this line (all units) in cents
            // - item.line_level_discount_allocations[] exists if discounts were applied per line
            console.log('item quantity is more than 0');
            const hasLineDiscounts = Array.isArray(item.line_level_discount_allocations) && item.line_level_discount_allocations.length > 0;

            // Per-unit discount in cents (e.g., 300 if 3.00 off each)
            const perUnitDiscount = (item.total_discount || 0) / item.quantity;

            // Effective unit price after discount (in cents)
            const effectiveUnitCents = Math.round(item.price - perUnitDiscount);

            // If we know what we expected (from the selected tier), compare with a 1-cent tolerance
            const matchesTierPrice =
                expectedUnitCents != null &&
                Math.abs(effectiveUnitCents - expectedUnitCents) <= 1;

            console.log(effectiveUnitCents - expectedUnitCents, 'effectiveUnitCents - expectedUnitCents');
            console.log(hasLineDiscounts, 'hasLineDiscounts');
            console.log(perUnitDiscount, 'perUnitDiscount');
            console.log(effectiveUnitCents, 'effectiveUnitCents');
            console.log(expectedUnitCents, 'expectedUnitCents');
            console.log(matchesTierPrice, 'matchesTierPrice');
            // We accept either "Shopify says there is a discount" OR "effective price == expected tier price"
            if (hasLineDiscounts || perUnitDiscount > 0 || matchesTierPrice) {
                return cart; // ✅ discount is applied
            }
        }

        // Not yet — wait a bit and try again
        await new Promise(r => setTimeout(r, interval));
    }

    // Gave it enough time — stop waiting
    throw new Error('Timed out waiting for Hulk discount to apply to the line item');
}

// Click Hulk's "Grab this deal", then confirm the cart updated for THIS variant
async function ensureDealAdded({ hulkCTASelector = '#card-list-button', timeout = 15000, interval = 250 } = {}) {
    const hulkCTA = document.querySelector(hulkCTASelector)
        || document.querySelector('.offer-option-btn')
        || document.querySelector('[onclick*="grab_deal"]');
    if (!hulkCTA) throw new Error('Hulk CTA not found');

    const variantId = getCurrentVariantId();     // tracks THIS product only
    console.log(variantId, 'variantId');
    const tierQty = getSelectedTierQty() || 1; // how many Hulk should add
    console.log(tierQty, 'tierQTY');

    // Baseline snapshot
    const before = await getCart();
    console.log(before, 'cart before');
    const baselineForVariant = variantId ? getVariantQtyInCart(before, variantId) : before.item_count;

    // Fire Hulk
    hulkCTA.click();

    // Poll cart until expected qty delta is present
    const deadline = Date.now() + timeout;
    const targetQty = (baselineForVariant || 0) + tierQty;

    while (Date.now() < deadline) {
        const cart = await getCart();

        if (variantId) {
            const qty = getVariantQtyInCart(cart, variantId);
            console.log(qty, 'variant quantity in cart');
            if (qty >= targetQty) return cart;           // ✅ confirmed for this variant
        } else {
            // Fallback if we couldn't read variant id
            if (cart.item_count > baselineForVariant) return cart;
        }

        await new Promise(r => setTimeout(r, interval));
    }

    throw new Error('Timed out waiting for the deal to be added to the cart');
}


async function checkoutBundleNow() {
    try {
        const cart = await ensureDealAdded();
        console.log('[OK] Deal confirmed in cart:', cart);
        const variantId = getCurrentVariantId();
        const expectedUnitCents = getSelectedTierUnitPriceCents();

        console.log(variantId, 'variantId after deal added');
        console.log(expectedUnitCents, 'expectedUnitCents after deal added')
        try {
            const cartAfterDiscount = await ensureDiscountApplied({
                variantId,
                expectedUnitCents
            });
            console.log('Discount confirmed:', cartAfterDiscount);
            // Next: click checkout, etc.
        } catch (e) {
            console.warn('Discount not confirmed in time:', e);
            // Optional: open the drawer so the user can see what happened
            try { window.theme?.cartDrawer?.open?.(); } catch (_) { }
        }
        // (Next steps later: verify discount, then click checkout.)
    } catch (e) {
        console.warn('[ERR] Could not confirm deal in cart:', e);
        // Optional: open drawer so the user sees state
        try { window.theme?.cartDrawer?.open?.(); } catch (_) { }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const checkoutButton = document.querySelector('.checkout-bundle');
    if (checkoutButton) {
        checkoutButton.addEventListener('click', checkoutBundleNow);
    }
});

class imageSwiperContainer extends HTMLElement {
    constructor() {
        super();
        this._swiper = null;
    }

    connectedCallback() {
        const el = this;

        const initializeSwiper = () => {
            // If we were connected before, don’t re-init.
            if (this._swiper && typeof this._swiper.destroy === 'function') {
                this._swiper.destroy(true, true);
                this._swiper = null;
                console.log('Swiper was destroyed');
            }

            const slides = el.querySelectorAll('.swiper-slide');
            const hasMultiple = slides.length > 1;
            const paginationEl = el.querySelector('.swiper-pagination');

            try {
                this._swiper = new Swiper(el, {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    observer: true,
                    observeParents: true,
                    resizeObserver: true,
                    watchOverflow: true,
                    loop: hasMultiple,
                    pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined,
                });
            } catch (e) {
                console.error('[image-swiper-container] init failed', e);
                return;
            }

            // Recalc after images load
            const imgs = el.querySelectorAll('img');
            let pending = 0;
            const update = () => this._swiper && this._swiper.update();
            imgs.forEach(img => {
                if (!img.complete) {
                    pending++;
                    img.addEventListener('load', update, { once: true });
                    img.addEventListener('error', update, { once: true });
                }
            });
            if (pending === 0) requestAnimationFrame(update);

            // Update when first visible
            try {
                const io = new IntersectionObserver(es => {
                    if (es.some(e => e.isIntersecting)) update();
                }, { threshold: 0.1 });
                io.observe(el);
            } catch { }
        };

        const waitForSwiper = () => {
            if (typeof window.Swiper !== 'undefined') {
                initializeSwiper();
            } else {
                setTimeout(waitForSwiper, 200);
            }
        };

        waitForSwiper();
    }

    disconnectedCallback() {
        if (this._swiper && typeof this._swiper.destroy === 'function') {
            this._swiper.destroy(true, true);
            this._swiper = null;
        }
    }
}
customElements.define('image-swiper-container', imageSwiperContainer);


(function () {
    const SEL = [
        '.product__price',
        '.grid-product__price',
        '.cart__price',
        '[data-product-price]',
        '[data-compare-price]',
        '.price',
        '.money',
        '.price__regular .price-item--regular',
        '.price__sale .price-item--sale',
        // Cart drawer / cart page subtotal & totals variants across themes
        '.totals__subtotal-value',
        '.cart-subtotal__price',
        '.cart__subtotal',
        '.drawer__footer [data-subtotal]',
        '.drawer__footer [data-cart-subtotal]',
        '[data-cart-subtotal]',
        '[data-subtotal]',
        '.ajaxcart__subtotal',
        '.js-ajaxcart-subtotal',
    ].join(',');

    const HULK_ALERT_SEL = '.hulkapps-reminder-msg';
    const CART_SCOPE_SEL = '#CartDrawer, [data-location="cart-drawer"], .drawer[data-location="cart-drawer"], .cart-drawer';
    function inCartScope(node) {
        try { return !!(node && node.closest && node.closest(CART_SCOPE_SEL)); } catch (e) { return false; }
    }

    function replaceAEDText(root) {
        if (!root || !root.isConnected) return;
        if (inCartScope(root)) return; // cart handled by the cart-scoped observer
        if (root.querySelector('.aed-symbol')) return; // already decorated

        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
        const targets = [];
        while (walker.nextNode()) {
            const tn = walker.currentNode;
            if (/\bAED\b|د\.إ/.test(tn.nodeValue)) targets.push(tn);
        }
        if (!targets.length) return;

        targets.forEach(tn => {
            const frag = document.createDocumentFragment();
            const parts = tn.nodeValue.split(/(AED|د\.إ)/);
            parts.forEach(part => {
                if (part === 'AED' || part === 'د.إ') {
                    const span = document.createElement('span');
                    span.className = 'aed-symbol';
                    span.setAttribute('aria-label', 'AED');
                    frag.appendChild(span);
                } else if (part) {
                    frag.appendChild(document.createTextNode(part));
                }
            });
            tn.parentNode && tn.parentNode.replaceChild(frag, tn);
        });
    }

    // Retry bookkeeping per element so we don't hammer the DOM
    const retryMap = new WeakMap();

    function extractNumeric(el) {
        const raw = (el.textContent || '').replace(/\s+/g, ' ').trim();
        const match = raw.match(/[0-9][0-9.,\s]*/);
        if (!match) return null;
        return match[0].replace(/\s/g, '');
    }

    function decorate(el, numeric) {
        el.innerHTML =
            '<span class="aed-symbol" aria-label="AED"></span>' +
            '<span class="money-amount">' + numeric + '</span>';
        el.dataset.aedAmount = numeric;
        el.dataset.aedDecorated = '1';
    }

    function scheduleRetry(el) {
        const prev = retryMap.get(el) || 0;
        if (prev >= 6) return; // stop after ~ (0 + 16 + 32 + 64 + 128 + 256)ms
        const delay = Math.max(0, 2 ** prev * 16);
        retryMap.set(el, prev + 1);
        setTimeout(() => normalize(el), delay);
    }

    function normalize(el) {
        if (!el || !el.isConnected) return;
        if (inCartScope(el)) return; // avoid touching cart subtree
        // If this is a Hulk alert message, only replace the AED text tokens
        if (el.matches(HULK_ALERT_SEL)) { replaceAEDText(el); return; }

        // Skip obvious containers or interactive blocks to avoid nuking content
        if (el.querySelector('button, input, select, textarea, form, .cart__items, .drawer__contents, .drawer__inner')) return;
        if (el.childElementCount > 3 && !el.matches('.totals__subtotal-value, [data-cart-subtotal], [data-subtotal]')) return;

        // If we already decorated and the amount didn't change, bail
        const numeric = extractNumeric(el);
        if (!numeric) { scheduleRetry(el); return; }
        if (el.dataset.aedAmount === numeric && el.querySelector('.aed-symbol')) return;

        // Defer one frame to let late innerHTML settle (AOS/filters/swipers)
        requestAnimationFrame(() => {
            if (!el.isConnected) return;
            const n2 = extractNumeric(el);
            if (!n2) { scheduleRetry(el); return; }
            if (el.dataset.aedAmount === n2 && el.querySelector('.aed-symbol')) return;
            decorate(el, n2);
        });
    }

    function sweep(root = document) {
        root.querySelectorAll(SEL).forEach(normalize);
    }

    // Initial double-RAF sweep to dodge first-paint races
    requestAnimationFrame(() => requestAnimationFrame(() => sweep()));

    const mo = new MutationObserver(muts => {
        for (const m of muts) {
            if (m.type === 'childList') {
                m.addedNodes.forEach(n => {
                    if (n.nodeType !== 1) return;
                    if (n.matches?.(SEL)) normalize(n);
                    if (n.matches?.(HULK_ALERT_SEL)) replaceAEDText(n);
                    // Delay sweep so children that are injected async get picked up
                    requestAnimationFrame(() => n.querySelectorAll?.(SEL).forEach(normalize));
                    requestAnimationFrame(() => n.querySelectorAll?.(HULK_ALERT_SEL).forEach(replaceAEDText));
                });
            } else if (m.type === 'characterData') {
                const el = m.target.parentElement;
                if (el?.matches?.(SEL)) normalize(el);
                if (el?.matches?.(HULK_ALERT_SEL)) replaceAEDText(el);
            } else if (m.type === 'attributes') {
                const el = m.target;
                if (el?.matches?.(SEL)) normalize(el);
                if (el?.matches?.(HULK_ALERT_SEL)) replaceAEDText(el);
            }
        }
    });

    mo.observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class', 'style']
    });

    ['shopify:section:load', 'shopify:section:select', 'shopify:section:reorder',
        'variant:change', 'variant:changed', 'product:variant-change', 'product:price-update']
        .forEach(evt => document.addEventListener(evt, e => sweep(e.target || document)));

    window.addEventListener('pageshow', () => requestAnimationFrame(() => sweep()));

    // Initial pass for Hulk reminders
    document.querySelectorAll(HULK_ALERT_SEL).forEach(replaceAEDText);
})();


(function () {
    // Cart containers we care about
    const CART_SEL = '#CartDrawer, [data-location="cart-drawer"], .drawer[data-location="cart-drawer"], .cart-drawer';
    const HULK_ALERT_SEL = '.hulkapps-reminder-msg';
    const SUBTOTAL_SEL = '#CartDrawer [data-subtotal], [data-location="cart-drawer"] [data-subtotal], #CartDrawer .cart-subtotal__price, #CartDrawer .totals__subtotal-value';
    const LINE_PRICE_SEL = '#CartDrawer .original_price, [data-location="cart-drawer"] .original_price, #CartDrawer .cart_price .original_price, #CartDrawer .discounted_price, [data-location="cart-drawer"] .discounted_price';
    const HULK_TOTAL_SEL = '#CartDrawer .hulkapps-cart-total, [data-location="cart-drawer"] .hulkapps-cart-total';

    // Track which subtotal nodes we are already watching
    const watchedSubtotals = new WeakSet();

    function watchSubtotal(el) {
        if (!el || watchedSubtotals.has(el)) return;
        watchedSubtotals.add(el);
        const o = new MutationObserver(() => {
            // normalize on any internal change (Hulk/Cart JS may rewrite children)
            normalizeSubtotal(el);
        });
        o.observe(el, { childList: true, subtree: true, characterData: true });
        // Keep a reference in case we ever want to disconnect: el._aedSubtotalObserver = o;
    }

    // Replace only the AED token(s) in text nodes with the icon span — leave numbers alone
    function replaceAEDText(root) {
        if (!root || !root.isConnected) return;
        if (!root.matches || !(root.matches(HULK_ALERT_SEL) || root.matches(HULK_TOTAL_SEL))) return; // only specific Hulk nodes

        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
        const targets = [];
        while (walker.nextNode()) {
            const tn = walker.currentNode;
            if (/\bAED\b|د\.إ/.test(tn.nodeValue)) targets.push(tn);
        }
        if (!targets.length) return;

        targets.forEach(tn => {
            const frag = document.createDocumentFragment();
            const parts = tn.nodeValue.split(/(AED|د\.إ)/);
            parts.forEach(part => {
                if (part === 'AED' || part === 'د.إ') {
                    const span = document.createElement('span');
                    span.className = 'aed-symbol';
                    span.setAttribute('aria-label', 'AED');
                    frag.appendChild(span);
                } else if (part) {
                    frag.appendChild(document.createTextNode(part));
                }
            });
            tn.parentNode && tn.parentNode.replaceChild(frag, tn);
        });
    }

    function extractNumeric(text) {
        const raw = (text || '').replace(/\s+/g, ' ').trim();
        const m = raw.match(/[0-9][0-9.,\s]*/);
        return m ? m[0].replace(/\s/g, '') : null;
    }

    function normalizeSubtotal(el) {
        if (!el || !el.isConnected) return;
        const doWrite = () => {
            const numeric = extractNumeric(el.textContent);
            if (!numeric) return;
            if (el.dataset.aedAmount === numeric && el.querySelector('.aed-symbol')) return;
            el.innerHTML = '<span class="aed-symbol" aria-label="AED"></span><span class="money-amount">' + numeric + '</span>';
            el.dataset.aedAmount = numeric;
            watchSubtotal(el); // begin watching this node for future internal rewrites
        };
        // Write now and also after layout settles to beat late rewrites
        doWrite();
        requestAnimationFrame(() => requestAnimationFrame(doWrite));
        setTimeout(doWrite, 64); // final safeguard after async drawer updates
    }

    function normalizeLinePrice(el) {
        if (!el || !el.isConnected) return;
        const numeric = extractNumeric(el.textContent);
        if (!numeric) return;
        if (el.dataset.aedAmount === numeric && el.querySelector('.aed-symbol')) return;
        el.innerHTML = '<span class="aed-symbol" aria-label="AED"></span><span class="money-amount">' + numeric + '</span>';
        el.dataset.aedAmount = numeric;
    }

    function processSubtree(root) {
        if (!root || root.nodeType !== 1) return;
        // Skip container wrappers that should not be rewritten
        if (root.matches('.cart__items, [data-cart-subtotal]')) return;
        // Subtotals
        console.log(root, 'subtotal root');
        if (root.matches && root.matches(SUBTOTAL_SEL)) { normalizeSubtotal(root); watchSubtotal(root); }
        root.querySelectorAll && root.querySelectorAll(SUBTOTAL_SEL).forEach(el => { normalizeSubtotal(el); watchSubtotal(el); });
        // Line item prices
        if (root.matches && root.matches(LINE_PRICE_SEL)) normalizeLinePrice(root);
        root.querySelectorAll && root.querySelectorAll(LINE_PRICE_SEL).forEach(normalizeLinePrice);
        // Hulk messages (replace AED token only)
        if (root.matches && (root.matches(HULK_ALERT_SEL) || root.matches(HULK_TOTAL_SEL))) replaceAEDText(root);
        root.querySelectorAll && root.querySelectorAll(HULK_ALERT_SEL + ', ' + HULK_TOTAL_SEL).forEach(replaceAEDText);
    }

    function isInCart(node) {
        if (!node || node.nodeType !== 1) return false;
        return !!node.closest(CART_SEL);
    }

    // Initial pass for any existing cart drawer(s)
    document.querySelectorAll(CART_SEL).forEach(processSubtree);

    // Observe at the body level but only act when mutations touch the cart subtree
    const mo = new MutationObserver(muts => {
        for (const m of muts) {
            if (m.type === 'childList') {
                m.addedNodes.forEach(n => {
                    if (n.nodeType !== 1) return;
                    if (isInCart(n)) {
                        processSubtree(n);
                    } else if (n.querySelector) {
                        const cartChild = n.querySelector(CART_SEL);
                        if (cartChild) processSubtree(cartChild);
                    }
                });
            } else if (m.type === 'characterData') {
                const el = m.target && m.target.parentElement;
                if (isInCart(el) && el && !el.matches('.cart__items, [data-cart-subtotal]')) {
                    if (el.matches && el.matches(SUBTOTAL_SEL)) normalizeSubtotal(el);
                    else if (el.matches && el.matches(LINE_PRICE_SEL)) normalizeLinePrice(el);
                    else if (el.closest && (el.closest(HULK_ALERT_SEL) || el.closest(HULK_TOTAL_SEL))) {
                        const tgt = el.closest(HULK_ALERT_SEL) || el.closest(HULK_TOTAL_SEL);
                        replaceAEDText(tgt);
                    }
                }
            }
        }
    });

    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
})();